import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/app/programare/components/AppointmentsPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppointmentsStateProvider"] */ "/app/apps/nextjs/src/hooks/useAppointments.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
